export const theme = {
  codeColor: Styles.color.white,
};
